import React from "react";
import ProfilePageTemplate from "../shared/ProfilePageTemplate";

const MisiKemanusiaanContent = () => {
  const missions = [
    {
      title: "Operasi SAR Malaysia 2021-2022",
      location: "Pantai Tanjung Balau, Johor Bahru, Malaysia",
      period: "20 Desember 2021 - 9 Januari 2022",
      type: "SAR, Evakuasi, Rehabilitasi, Identifikasi dan DVI",
      description:
        "Operasi Misi Kemanusiaan Internasional SAR, Evakuasi Laut dan Udara Gakkum, Rehabilitasi, Identifikasi dan DVI Korban Tenggelamnya Kapal Fiber Boat",
      legalBasis:
        "Sprin Kapolri Nomor: Sprin/3088/XII/OPS.3.1.2/2021 tanggal 20 Desember 2021",
      status: "Selesai",
      icon: "🚁",
    },
    {
      title: "Bantuan Gempa Bumi Turkiye 2023",
      location: "Turkiye",
      period: "Februari 2023",
      type: "Bantuan Kemanusiaan",
      description:
        "Operasi Misi Kemanusiaan Internasional Bantuan Kemanusiaan Terhadap Korban Gempa Bumi di Turkiye",
      legalBasis:
        "Sprin Kapolri Nomor: Sprin/402/II/2023 tanggal 8 Februari 2023",
      personnel: {
        wave1: { count: 4, type: "K-9 Satgas MUSAR", date: "11 Februari 2023" },
        wave2: { count: 23, type: "Satgas EMT", date: "13 Februari 2023" },
      },
      status: "Selesai",
      icon: "🏥",
    },
    {
      title: "Misi Kemanusiaan Palestina 2023",
      location: "El-Arish, Mesir - Palestina",
      period: "4 - 6 November 2023",
      type: "Bantuan Kemanusiaan",
      description: "Operasi Misi Kemanusiaan Internasional untuk Palestina",
      legalBasis:
        "Sprin Kapolri Nomor: Sprin/3329/XI/OPS.3.1.2./2023 tanggal 7 November 2023",
      personnel: {
        total: 9,
        leader: "Kadivhubinter",
        departure:
          "06 November 2023 pukul 01.00 WIB dari Soekarno Hatta International Airport",
      },
      status: "Selesai",
      icon: "🕊️",
    },
  ];

  const OverviewContent = () => (
    <div className="p-8">
      <div className="space-y-8">
        {/* Introduction */}
        <div className="bg-base-200 rounded-xl p-6">
          <h2 className="text-2xl font-bold mb-6">Misi Kemanusiaan Polri</h2>
          <p className="leading-relaxed text-base-content/70 mb-4">
            Polri berkomitmen dalam memberikan bantuan kemanusiaan internasional
            melalui berbagai operasi yang meliputi Search and Rescue (SAR),
            bantuan bencana alam, dan dukungan kemanusiaan di berbagai wilayah
            yang membutuhkan.
          </p>
          <p className="leading-relaxed text-base-content/70">
            Dalam periode 2022-2025, Polri telah melaksanakan beberapa misi
            kemanusiaan internasional yang menunjukkan komitmen Indonesia dalam
            solidaritas global dan bantuan kemanusiaan.
          </p>
        </div>

        {/* Mission Statistics */}
        <div className="bg-base-200 rounded-xl p-6">
          <h2 className="text-2xl font-bold mb-6">
            Statistik Misi Kemanusiaan (2022-2025)
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
            <div className="bg-primary/10 rounded-lg p-6 text-center border-2 border-primary/20">
              <div className="text-3xl mb-3">🌍</div>
              <h3 className="font-semibold text-lg mb-2">Total Misi</h3>
              <p className="text-primary font-bold text-2xl">
                {missions.length}
              </p>
            </div>

            <div className="bg-secondary/10 rounded-lg p-6 text-center border-2 border-secondary/20">
              <div className="text-3xl mb-3">👥</div>
              <h3 className="font-semibold text-lg mb-2">Total Personel</h3>
              <p className="text-secondary font-bold text-2xl">36+</p>
            </div>

            <div className="bg-accent/10 rounded-lg p-6 text-center border-2 border-accent/20">
              <div className="text-3xl mb-3">🏳️</div>
              <h3 className="font-semibold text-lg mb-2">Negara Terlibat</h3>
              <p className="text-accent font-bold text-2xl">3</p>
            </div>

            <div className="bg-success/10 rounded-lg p-6 text-center border-2 border-success/20">
              <div className="text-3xl mb-3">⚡</div>
              <h3 className="font-semibold text-lg mb-2">Respons Cepat</h3>
              <p className="text-success font-bold text-xl">24-72 Jam</p>
            </div>
          </div>
        </div>

        {/* Mission Types */}
        <div className="bg-base-200 rounded-xl p-6">
          <h2 className="text-2xl font-bold mb-6">Jenis Misi Kemanusiaan</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            <div className="bg-base-100 rounded-lg p-6 text-center">
              <div className="text-3xl mb-3">🚁</div>
              <h3 className="font-semibold text-lg mb-3">
                Search and Rescue (SAR)
              </h3>
              <p className="text-base-content/70 text-sm">
                Operasi pencarian dan penyelamatan korban bencana
              </p>
            </div>

            <div className="bg-base-100 rounded-lg p-6 text-center">
              <div className="text-3xl mb-3">🏥</div>
              <h3 className="font-semibold text-lg mb-3">
                Emergency Medical Team
              </h3>
              <p className="text-base-content/70 text-sm">
                Tim medis darurat untuk bantuan kesehatan
              </p>
            </div>

            <div className="bg-base-100 rounded-lg p-6 text-center">
              <div className="text-3xl mb-3">🔍</div>
              <h3 className="font-semibold text-lg mb-3">
                Disaster Victim Identification
              </h3>
              <p className="text-base-content/70 text-sm">
                Identifikasi korban bencana dan forensik
              </p>
            </div>

            <div className="bg-base-100 rounded-lg p-6 text-center">
              <div className="text-3xl mb-3">🐕</div>
              <h3 className="font-semibold text-lg mb-3">K-9 Unit</h3>
              <p className="text-base-content/70 text-sm">
                Unit anjing pelacak untuk operasi pencarian
              </p>
            </div>

            <div className="bg-base-100 rounded-lg p-6 text-center">
              <div className="text-3xl mb-3">📦</div>
              <h3 className="font-semibold text-lg mb-3">Bantuan Logistik</h3>
              <p className="text-base-content/70 text-sm">
                Distribusi bantuan kemanusiaan dan logistik
              </p>
            </div>

            <div className="bg-base-100 rounded-lg p-6 text-center">
              <div className="text-3xl mb-3">🔧</div>
              <h3 className="font-semibold text-lg mb-3">Rehabilitasi</h3>
              <p className="text-base-content/70 text-sm">
                Dukungan rehabilitasi dan pemulihan
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  const MissionsContent = () => (
    <div className="p-8">
      <div className="space-y-8">
        {missions.map((mission, index) => {
          // Define image ranges for each mission
          const getImageRange = (missionIndex: number) => {
            switch (missionIndex) {
              case 0:
                return [1, 2, 3]; // SAR Malaysia
              case 1:
                return [4, 5, 6]; // Turkiye
              case 2:
                return [7, 8]; // Palestine
              default:
                return [];
            }
          };

          const imageNumbers = getImageRange(index);

          return (
            <div key={index} className="bg-base-200 rounded-xl p-6">
              <div className="flex flex-col lg:flex-row gap-6">
                {/* Content Section */}
                <div className="lg:w-2/3">
                  <div className="flex items-start gap-4 mb-6">
                    <div className="text-4xl">{mission.icon}</div>
                    <div className="flex-1">
                      <h3 className="text-xl font-bold mb-2">
                        {mission.title}
                      </h3>
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                        <div className="flex items-center gap-2 text-sm">
                          <span className="text-base-content/50">📍</span>
                          <span>{mission.location}</span>
                        </div>
                        <div className="flex items-center gap-2 text-sm">
                          <span className="text-base-content/50">📅</span>
                          <span>{mission.period}</span>
                        </div>
                        <div className="flex items-center gap-2 text-sm">
                          <span className="text-base-content/50">🎯</span>
                          <span>{mission.type}</span>
                        </div>
                        <div className="flex items-center gap-2 text-sm">
                          <span className="text-base-content/50">✅</span>
                          <span className="badge badge-success">
                            {mission.status}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="bg-base-100 rounded-lg p-4 mb-4">
                    <p className="text-base-content/70 leading-relaxed">
                      {mission.description}
                    </p>
                  </div>

                  {mission.personnel && (
                    <div className="bg-base-100 rounded-lg p-4 mb-4">
                      <h4 className="font-semibold mb-3">Detail Personel:</h4>
                      {mission.personnel.wave1 && (
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                          <div className="bg-primary/10 rounded-lg p-3">
                            <h5 className="font-medium text-sm mb-1">
                              Gelombang Pertama
                            </h5>
                            <p className="text-xs text-base-content/70">
                              {mission.personnel.wave1.count} personel{" "}
                              {mission.personnel.wave1.type} (
                              {mission.personnel.wave1.date})
                            </p>
                          </div>
                          <div className="bg-secondary/10 rounded-lg p-3">
                            <h5 className="font-medium text-sm mb-1">
                              Gelombang Kedua
                            </h5>
                            <p className="text-xs text-base-content/70">
                              {mission.personnel.wave2.count} personel{" "}
                              {mission.personnel.wave2.type} (
                              {mission.personnel.wave2.date})
                            </p>
                          </div>
                        </div>
                      )}
                      {mission.personnel.total && (
                        <div className="bg-accent/10 rounded-lg p-3">
                          <h5 className="font-medium text-sm mb-1">
                            Komposisi Tim
                          </h5>
                          <p className="text-xs text-base-content/70">
                            {mission.personnel.total} personel dipimpin oleh{" "}
                            {mission.personnel.leader}
                          </p>
                          <p className="text-xs text-base-content/70 mt-1">
                            Keberangkatan: {mission.personnel.departure}
                          </p>
                        </div>
                      )}
                    </div>
                  )}

                  <div className="bg-base-300/50 rounded-lg p-3">
                    <h4 className="font-medium text-sm mb-1">Dasar Hukum:</h4>
                    <p className="text-xs text-base-content/70">
                      {mission.legalBasis}
                    </p>
                  </div>
                </div>

                {/* Images Section */}
                {imageNumbers.length > 0 && (
                  <div className="lg:w-1/3">
                    <div className="bg-base-100 rounded-lg p-4">
                      <h4 className="font-semibold mb-3 text-center">
                        Dokumentasi Misi
                      </h4>
                      <div className="grid gap-3">
                        {imageNumbers.map((imgNumber) => (
                          <div
                            key={imgNumber}
                            className="bg-base-200 rounded-lg overflow-hidden shadow-md hover:shadow-lg transition-shadow"
                          >
                            <img
                              src={`/gallery/misi-kemanusiaan/Misi Kemanusiaan_${imgNumber - 1}.jpg`}
                              alt={`${mission.title} dokumentasi ${imgNumber}`}
                              loading="lazy"
                              className="w-full h-40 object-cover hover:scale-105 transition-transform duration-300 cursor-pointer"
                              onError={(e) => {
                                const target = e.target as HTMLImageElement;
                                target.src = "/placeholder-image.jpg";
                                target.alt = "Gambar tidak tersedia";
                              }}
                              onClick={() =>
                                window.open(
                                  `/gallery/misi-kemanusiaan/Misi Kemanusiaan_${imgNumber - 1}.jpg`,
                                  "_blank",
                                )
                              }
                            />
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );

  const tabs = [
    {
      id: "overview",
      label: "Gambaran Umum",
      icon: "🌍",
      component: <OverviewContent />,
    },
    {
      id: "missions",
      label: "Misi Terlaksana",
      icon: "📋",
      component: <MissionsContent />,
    },
  ];

  return (
    <ProfilePageTemplate
      title="Misi Kemanusiaan"
      subtitle="Bantuan Kemanusiaan Internasional Polri"
      icon="❤️"
      breadcrumbBase="Misi Internasional"
      tabs={tabs}
      footerTitle="Misi Kemanusiaan Polri"
      footerDescription="Menunjukkan solidaritas global Indonesia melalui berbagai operasi bantuan kemanusiaan internasional yang cepat tanggap dan profesional."
      footerStats={[
        { label: "Misi Terlaksana", value: "3" },
        { label: "Personel Terlibat", value: "36+" },
        { label: "Negara Terbantu", value: "3" },
      ]}
    />
  );
};

export default MisiKemanusiaanContent;
